import { createReducer } from 'redux-act';
import * as actions from '#app/actions/goalPlan';

interface GoalPlanState {
  modalVisible: boolean;
  form: Record<string, unknown>;
}

const initialState: GoalPlanState = {
  modalVisible: false,
  form: {},
};

const setGoalPlanModalVisible = (state: GoalPlanState, bool: boolean): GoalPlanState => ({
  ...state,
  modalVisible: bool,
});

const setGoalPlanForm = (state: GoalPlanState, form: Record<string, unknown>): GoalPlanState => ({
  ...state,
  form: form,
  modalVisible: true,
});

const closeGoalPlanForm = (state: GoalPlanState): GoalPlanState => ({
  ...state,
  form: {},
  modalVisible: false,
});

export default createReducer<GoalPlanState>(
  {
    [actions.setGoalPlanModalVisible as any]: setGoalPlanModalVisible,
    [actions.setGoalPlanForm as any]: setGoalPlanForm,
    [actions.closeGoalPlanForm as any]: closeGoalPlanForm,
  },
  initialState
);
